import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function HandIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M4.7 7.667v1.666m0-1.666v-4c0-.553.492-1 1.1-1s1.1.447 1.1 1m-2.2 4c0-.553-.492-1-1.1-1s-1.1.447-1.1 1V9c0 2.761 2.462 5 5.5 5s5.5-2.239 5.5-5V5.667c0-.553-.492-1-1.1-1-.607 0-1.1.447-1.1 1m-4.4-2v3.666m0-3.666V3c0-.552.492-1 1.1-1s1.1.448 1.1 1v.667m0 0v3.666m0-3.666c0-.553.492-1 1.1-1 .607 0 1.1.447 1.1 1v2m0 0v1.666" /></svg>
  );
}

export default HandIcon;
